import {
    Box,
    Flex,
    Grid,
    GridItem,
    Image,
    List,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";

import ModalRegistro from "@/components/inmobiliarias/ModalRegistro";

export const Content = () => {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    return (
        <>
            <Box
                {...(!isGreaterThanMd && { full: "full" })}
                mb={isGreaterThanMd ? "14" : "8"}
                maxW="7xl"
                mx="auto"
            >
                <Box w="full" mx="auto" maxW="7xl" paddingInline="0">
                    <Flex
                        w="100%"
                        h="65vh"
                        id="fondo"
                        backgroundImage="url(https://media.grupoguia.mx/assets/Inmobiliarias/Banners/banner-principal.webp)"
                        backgroundSize="cover"
                        backgroundPosition="center center"
                        backgroundRepeat="no-repeat"
                        position="relative"
                        p="0"
                        bgColor="gray.100"
                        borderRadius="20px"
                    >
                        <Flex
                            direction="column"
                            w="100%"
                            position="absolute"
                            left="0"
                            right="0"
                            height="100%"
                            paddingBottom={0}
                            justifyContent="center"
                            alignItems="center"
                            color="white"
                            borderRadius="20px"
                            bg="#00000047"
                            textAlign="center"
                        >
                            <Text fontWeight="600" fontSize={isGreaterThanMd ? "4xl" : "2xl"}>
                                Eres inmobiliaria
                            </Text>
                            <ModalRegistro guiaBroker={true} small={true} />
                        </Flex>
                    </Flex>
                </Box>
            </Box>
            <Flex mt={20} flexDirection="column">
                <Stack textAlign="center" mb={4}>
                    <Text fontWeight="700" fontSize={isGreaterThanMd ? "2xl" : "xl"}>
                        Proceso de registro
                    </Text>
                    <Text fontWeight="400" fontSize={isGreaterThanMd ? "lg" : "md"} mt={2}>
                        Para registrar a tus clientes, sigue este proceso:
                    </Text>
                </Stack>
                <Grid
                    templateColumns="repeat(2, 1fr)"
                    gap={8}
                    alignItems="center"
                    justifyContent="center"
                    mt={2}
                    pt={6}
                    maxW="7xl"
                    mx={{ base: 4, xl: "auto" }}
                    my={12}
                >
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 3}
                        alignItems="center"
                        marginRight="auto"
                        borderWidth="1px"
                        borderColor="#BEBEBE"
                        w="full"
                        h="full"
                        borderRadius="md"
                    >
                        <Flex h="100%" alignItems="center" justifyContent="center" px={4} py={6}>
                            <Image
                                src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/icon-1.webp"
                                alt="simple icon"
                                display="inline-flex"
                                width="72px"
                                h="auto"
                                marginRight={8}
                            />
                            <Box>
                                <Text fontSize="lg" color="black" fontWeight={600}>
                                    1. Registro de clientes
                                </Text>
                                <ModalRegistro />
                            </Box>
                        </Flex>
                    </GridItem>
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 3}
                        alignItems="center"
                        marginLeft={isGreaterThanMd ? "auto" : 0}
                        marginRight="auto"
                        borderWidth="1px"
                        borderColor="#BEBEBE"
                        w="full"
                        h="full"
                        borderRadius="md"
                    >
                        <Flex h="100%" alignItems="center" justifyContent="center" px={4} py={6}>
                            <Image
                                src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/proceso/crm.svg"
                                alt="simple icon"
                                display="inline-flex"
                                width="72px"
                                h="auto"
                                marginRight={8}
                                ml={8}
                            />
                            <Box>
                                <Text fontSize="lg" color="black" fontWeight={600}>
                                    2. Validación en CRM
                                </Text>
                                <Text as="span" fontWeight={400}>
                                    Con base en las políticas del programa, el equipo comercial de
                                    Grupo Guía revisará cada uno de los registros para validar si el
                                    cliente puede ser atendido por la inmobiliaria a través de Guía
                                    Brokers.
                                </Text>
                            </Box>
                        </Flex>
                    </GridItem>
                </Grid>
            </Flex>
            <Flex mb={2} mt={2} direction="column">
                <Stack textAlign="center" mb={4}>
                    <Text fontWeight="700" fontSize={isGreaterThanMd ? "2xl" : "xl"}>
                        Confirmación
                    </Text>
                </Stack>
                <Grid
                    templateColumns="repeat(2, 1fr)"
                    gap={8}
                    alignItems="center"
                    mt={2}
                    pt={6}
                    maxW="7xl"
                    mx={{ base: 4, xl: "auto" }}
                    my={12}
                >
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 3}
                        alignItems="center"
                        mx="auto"
                        borderWidth="1px"
                        borderColor="#BEBEBE"
                        w="full"
                        h="full"
                        borderRadius="md"
                    >
                        <Flex h="100%" alignItems="center" justifyContent="center" px={4} py={6}>
                            <Image
                                src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/proceso/error.svg"
                                alt="simple icon"
                                display="inline-flex"
                                width="72px"
                                h="auto"
                                marginRight={8}
                                ml={8}
                            />
                            <Box>
                                <Text fontSize="lg" color="black" fontWeight={600} mb={2}>
                                    3. No exitoso
                                </Text>
                                <Text fontSize="md" color="black" fontWeight={400}>
                                    El equipo contactará a la inmobiliaria para informarle la razón
                                    de por qué el registro del cliente no fue exitoso, con base en
                                    las políticas del programa.
                                </Text>
                            </Box>
                        </Flex>
                    </GridItem>
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 3}
                        alignItems="center"
                        marginLeft={isGreaterThanMd ? "auto" : 0}
                        marginRight="auto"
                        borderWidth="1px"
                        borderColor="#BEBEBE"
                        w="full"
                        h="full"
                        borderRadius="md"
                    >
                        <Flex h="100%" alignItems="center" justifyContent="center" px={4} py={6}>
                            <Image
                                src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/proceso/exito.svg"
                                alt="simple icon"
                                display="inline-flex"
                                width="72px"
                                h="auto"
                                marginRight={8}
                                ml={8}
                            />
                            <Box>
                                <Text fontSize="lg" color="black" fontWeight={600} mb={2}>
                                    4. Exitoso
                                </Text>
                                <Text as="span" fontWeight={400}>
                                    El asesor de Guía se pondrá en contacto directo con el asesor de
                                    la inmobiliaria para en conjunto dar el seguimiento
                                    correspondiente al cliente.
                                </Text>
                            </Box>
                        </Flex>
                    </GridItem>
                </Grid>
            </Flex>
            <Box mb={20} mt={2}>
                <Stack
                    alignItems="center"
                    borderWidth="1px"
                    borderColor="#BEBEBE"
                    w={{ base: "95vw", md: "60vw", xl: "30%" }}
                    maxW="500px"
                    h="full"
                    borderRadius="md"
                    bg="#F4F4F4"
                    mx="auto"
                >
                    <Flex h="100%" alignItems="center" justifyContent="center" px={4} py={6}>
                        <Image
                            src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/proceso/trofeo.svg"
                            alt="simple icon"
                            display="inline-flex"
                            width="72px"
                            h="auto"
                            marginRight={8}
                            ml={8}
                        />
                        <Text fontWeight={400} mr={8}>
                            El asesor se pondrá en contacto a la brevedad para darle
                            <br />
                            seguimiento y apoyo al asesor inmobiliario.
                        </Text>
                    </Flex>
                </Stack>
            </Box>
            <Box {...(!isGreaterThanMd && { full: "full" })} mb={isGreaterThanMd ? "14" : "8"}>
                <Box w="full" mx="auto" maxW="7xl" paddingInline="0">
                    <Flex
                        w="100%"
                        h="40vh"
                        id="fondo"
                        backgroundImage="url(https://media.grupoguia.mx/assets/Inmobiliarias/Banners/banner2.webp)"
                        backgroundSize="cover"
                        backgroundPosition="center center"
                        backgroundRepeat="no-repeat"
                        position="relative"
                        p="0"
                        bgColor="gray.100"
                        borderRadius="20px"
                    >
                        <Flex
                            direction="column"
                            w="100%"
                            position="absolute"
                            left="0"
                            right="0"
                            height="100%"
                            paddingBottom={0}
                            justifyContent="center"
                            alignItems="center"
                            color="white"
                            borderRadius="20px"
                            bg="#00000080"
                            textAlign={{ base: "justify", md: "center" }}
                            px={{ base: 5, md: 0 }}
                        >
                            <Text fontWeight="700" fontSize={isGreaterThanMd ? "4xl" : "2xl"}>
                                Proceso para el cobro de comisiones
                            </Text>
                            <Text fontWeight="400" fontSize={isGreaterThanMd ? "lg" : "md"}>
                                Este proceso se iniciará una vez que se haya firmado el contrato de
                                compraventa <br />y se hará siguiendo los siguientes pasos:
                            </Text>
                        </Flex>
                    </Flex>
                </Box>
            </Box>

            <Box mt={20} mb={10} mx={{ base: 3, md: 5, lg: 10, xl: 20 }}>
                <Stack justifyContent="center">
                    <Flex alignSelf="center">
                        <Image
                            src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/comisiones/documentacion.svg"
                            mr="4"
                            alt="simple icon"
                        />
                        <Text fontWeight={400} fontSize="md" color="black">
                            <strong>1. Documentación</strong>
                            <br />
                            El Concierge Inmobiliario enviará un link para que el asesor externo
                            comparta la siguiente documentación completa y vigente.
                        </Text>
                    </Flex>
                </Stack>
                <Flex my={12} display={{ base: "block", md: "flex" }}>
                    <Box
                        w={{ base: "100%", md: "40%" }}
                        p={7}
                        mr={5}
                        borderWidth="1px"
                        borderRadius="10px"
                        borderColor="#BEBEBE"
                    >
                        <Text fontWeight="700">Persona Física:</Text>
                        <List.Root
                            fontSize="md"
                            color="black"
                            fontWeight={400}
                            mt={2}
                            ml={6}
                            gap="1.5"
                        >
                            <List.Item>
                                CSF (certificado de situación fiscal) no mayor a 3 meses.
                            </List.Item>
                            <List.Item>Opinión de Cumplimiento Positiva</List.Item>
                            <List.Item>Comprobante de Domicilio (no mayor a 3 meses).</List.Item>
                            <List.Item>Identificación Oficial vigente.</List.Item>
                            <List.Item>Carátula Bancaria con clabe.</List.Item>
                            <List.Item>
                                Datos del representante legal (nombre completo, correo, celular).
                            </List.Item>
                        </List.Root>
                    </Box>
                    <Box
                        w={{ base: "100%", md: "60%" }}
                        p={7}
                        mt={{ base: 5, md: 0 }}
                        ml={{ base: 0, md: 5 }}
                        borderWidth="1px"
                        borderRadius="10px"
                        borderColor="#BEBEBE"
                    >
                        <Text fontWeight="700">Persona Moral:</Text>
                        <List.Root
                            fontSize="md"
                            color="black"
                            fontWeight={400}
                            mt={2}
                            ml={6}
                            gap="1.5"
                        >
                            <List.Item>
                                CSF (certificado de situación fiscal) no mayor a 3 meses.
                            </List.Item>
                            <List.Item>Opinión de Cumplimiento Positiva</List.Item>
                            <List.Item>Comprobante de Domicilio.</List.Item>
                            <List.Item>Identificación Oficial vigente.</List.Item>
                            <List.Item>Carátula Bancaria con clabe.</List.Item>
                            <List.Item>
                                Datos del representante legal (nombre completo, correo, celular).
                            </List.Item>
                            <List.Item>
                                Acta constitutiva de la empresa con Boleta Registral y poder del
                                representante legal.
                            </List.Item>
                        </List.Root>
                    </Box>
                </Flex>
                <Text
                    px={isGreaterThanMd ? 8 : 2}
                    fontWeight="400"
                    fontSize={isGreaterThanMd ? "md" : "sm"}
                >
                    Guía almacenará cualquier cuenta bancaria que nos compartan, si en el futuro nos
                    comparten otra cuenta entenderemos que podremos pagar la comisión en cualquiera
                    de las cuentas y así consecutivamente. En caso de requerir que dejemos de usar
                    una cuenta, se deberá enviar mail a mgutierrez@grupoguia.mx; esilva@grupoguia.mx
                    y compras@grupoguia.mx para poder llevar a cabo el proceso, una vez recibido el
                    mail el movimiento se aplicaría 48 horas hábiles después.
                </Text>
                <Stack justifyContent="center" px={isGreaterThanMd ? 8 : 2} marginTop={10}>
                    <Flex alignItems="center">
                        <Image
                            src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/comisiones/factura.svg"
                            mr="4"
                            alt="simple icon"
                            maxH="70px"
                        />
                        <Box
                            fontWeight={400}
                            color="black"
                            fontSize={isGreaterThanMd ? "md" : "sm"}
                        >
                            <strong>2. Envío de factura</strong>
                            <br />
                            <Text>
                                Una vez verificado el pago del desarrollador a Grupo Guia se le
                                solicitará a la inmobiliaria enviar su factura con las
                                especificaciones necesarias (monto exacto, concepto, uso de CFDI,
                                etc.) los cuales se le brindarán por parte de la persona encargada
                                del área de Post-venta.
                            </Text>
                        </Box>
                    </Flex>
                </Stack>
                <Stack justifyContent="center" px={isGreaterThanMd ? 8 : 2} marginTop={10}>
                    <Flex alignItems="center">
                        <Image
                            src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/comisiones/convenio.svg"
                            mr="4"
                            alt="simple icon"
                            maxH="70px"
                        />
                        <Box
                            fontWeight={400}
                            color="black"
                            fontSize={isGreaterThanMd ? "md" : "sm"}
                        >
                            <strong>3. Convenio mercantil</strong>
                            <br />
                            <Text mt={2} fontSize="sm">
                                1. El representante legal de la inmobiliaria recibirá por correo el
                                convenio mercantil por un año, este convenio avala las operaciones
                                realizadas en el desarrollo.
                            </Text>
                            <Text mt={2} fontSize="sm">
                                2. Firma FAD: Aprobado el convenio, se le enviará al representante
                                legal la liga FAD para recabar la firma digital (solo se puede abrir
                                por celular).
                            </Text>
                            <Text mt={3} fontSize="xs">
                                *Si la actividad económica inmobiliaria no es el giro perteneciente
                                a los bienes raíces, NO se podrá hacer el pago correspondiente.
                            </Text>
                        </Box>
                    </Flex>
                </Stack>
                <Stack justifyContent="center" px={isGreaterThanMd ? 8 : 2} marginTop={10}>
                    <Flex alignItems="center">
                        <Image
                            src="https://media.grupoguia.mx/assets/Inmobiliarias/Icons/comisiones/comprobante.svg"
                            mr="4"
                            alt="simple icon"
                            maxH="70px"
                        />
                        <Box
                            fontWeight={400}
                            color="black"
                            fontSize={isGreaterThanMd ? "md" : "sm"}
                        >
                            <strong>4. Comprobante de pago</strong>
                            <br />
                            <Text mt={2} fontSize="sm">
                                Una vez recibida la factura, en un plazo aproximado de 48 horas, se
                                hará el depósito de la comisión correspondiente y se enviará el
                                comprobante de pago.
                            </Text>
                            <Text mt={4} fontSize="xs">
                                {`*Queda estrictamente prohibido que los asesores de Grupo Guía
                                    contacten de manera directa al cliente de la inmobiliaria. Todo
                                    seguimiento al cliente de la inmobiliaria debe ser a través del
                                    ASESOR INMOBILIARIO EXTERNO, de igual manera el asesor de Grupo Guía
                                    deberá registrar el seguimiento que le indique la inmobiliaria
                                    dentro del CRM controlado por Grupo Guia, ya que estos registros
                                    también se sujetan a la política del CRM: "La vigencia de un negocio
                                    es de 30 días a partir de la última interacción. La interacción se
                                    considera a partir de la acción, relación y comunicación entre 2 o
                                    más personas con la intención de concretar un negocio registrado.`}
                            </Text>
                        </Box>
                    </Flex>
                </Stack>
                <Stack mx="auto" mt="70px" maxW="250px">
                    <ModalRegistro guiaBroker={true} small={true} />
                </Stack>
            </Box>
        </>
    );
};
